import { render, staticRenderFns } from "./ModalAgendamentosPaciente.vue?vue&type=template&id=3e930e92&scoped=true"
import script from "./ModalAgendamentosPaciente.vue?vue&type=script&lang=js"
export * from "./ModalAgendamentosPaciente.vue?vue&type=script&lang=js"
import style0 from "./ModalAgendamentosPaciente.vue?vue&type=style&index=0&id=3e930e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e930e92",
  null
  
)

export default component.exports